import { Link } from 'react-router-dom';
import logo from './logo_nav.png';
import './style.css';

export default function NavLogo({ mobile = false }) {
  return (
    <Link to="/" className={`nav-logo ${mobile ? 'nav-logo-mobile' : 'nav-logo-desktop'}`} aria-label="Store2Door home">
      <img src={logo} alt="Store2Door Direct" width="300" height="100" />
    </Link>
  );
}
